"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _UIHeader = _interopRequireDefault(require("UIComponents/layout/UIHeader"));

var _UILogo = _interopRequireDefault(require("UIComponents/image/UILogo"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _HeaderTabs = _interopRequireDefault(require("../constants/HeaderTabs"));

var _utils = require("../utils/utils");

var _langUtils = require("../utils/langUtils");

var _GoodsActions = require("../actions/GoodsActions");

var _managePurchasesPrefetcher = require("../prefetchers/managePurchasesPrefetcher");

var _MarketplaceNavAlert = _interopRequireDefault(require("../containers/MarketplaceNavAlert"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  top: -1px;\n  margin-right: ", "px;\n  padding-right: ", "px;\n\n  /* Match page title font size, account for sprocket */\n  height: 1.2em;\n\n  border-right: 1px solid ", ";\n  vertical-align: text-bottom !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var LOGO_SPACING = 16;
var StyledLogo = (0, _styledComponents.default)(_UILogo.default).withConfig({
  displayName: "AppHeader__StyledLogo",
  componentId: "uqxf9j-0"
})(_templateObject(), LOGO_SPACING, LOGO_SPACING, _colors.GREAT_WHITE);

var AppHeader =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AppHeader, _Component);

  function AppHeader() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, AppHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AppHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handlePurchasedMouseEnter = function () {
      if (_this.props.isCustomer) {
        (0, _managePurchasesPrefetcher.managePurchasesPrefetcher)();
      }
    };

    _this.handleTabClick = function (event) {
      if (event.target.value === _HeaderTabs.default.STOREFRONT) {
        _this.props.goToAllProducts();
      } else {
        if (_this.props.isCustomer) {
          _this.props.goToManagePurchases();
        } else {
          window.location = (0, _utils.getRedirectToPurchases)();
        }
      }
    };

    _this.renderTitle = function (isCustomer) {
      var title = _react.default.createElement(_FormattedMessage.default, {
        message: "header.title"
      });

      if (isCustomer) {
        return title;
      }

      return _react.default.createElement("div", null, _react.default.createElement(StyledLogo, {
        name: "hubspot-wordmark"
      }), title);
    };

    return _this;
  }

  (0, _createClass2.default)(AppHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          currentTab = _this$props.currentTab,
          isCustomer = _this$props.isCustomer,
          searchBarComponent = _this$props.searchBarComponent;
      return _react.default.createElement(_react.Fragment, null, isCustomer && _react.default.createElement(_MarketplaceNavAlert.default, null), _react.default.createElement(_UIHeader.default, {
        tabs: _react.default.createElement(_UITabs.default, {
          defaultSelected: currentTab,
          onSelectedChange: this.handleTabClick
        }, _react.default.createElement(_UITab.default, {
          tabId: _HeaderTabs.default.STOREFRONT,
          title: (0, _langUtils.getHeaderTabText)(_HeaderTabs.default.STOREFRONT)
        }), _react.default.createElement(_UITab.default, {
          onMouseEnter: this.handlePurchasedMouseEnter,
          tabId: _HeaderTabs.default.PURCHASED,
          title: (0, _langUtils.getHeaderTabText)(_HeaderTabs.default.PURCHASED)
        })),
        title: this.renderTitle(isCustomer),
        use: "condensed"
      }, searchBarComponent && _react.default.createElement("div", {
        className: "header-search-bar"
      }, searchBarComponent)));
    }
  }]);
  return AppHeader;
}(_react.Component);

AppHeader.propTypes = {
  currentTab: _react.PropTypes.string,
  goToAllProducts: _react.PropTypes.func.isRequired,
  goToManagePurchases: _react.PropTypes.func.isRequired,
  isCustomer: _react.PropTypes.bool.isRequired,
  searchBarComponent: _react.PropTypes.node
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isCustomer: (0, _utils.isCustomer)(state.auth.portal)
  };
};

var mapDispatchToProps = {
  goToAllProducts: _GoodsActions.goToAllProducts,
  goToManagePurchases: _GoodsActions.goToManagePurchases
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppHeader);

exports.default = _default;
module.exports = exports.default;